import type { Beehiiv } from "@beehiiv/sdk"
import { Disclaimer } from "@/components/resources/components/Disclaimer"
import { ArticleHero } from "@/components/resources/components/Hero"
import { ArticleSchema } from "@/components/resources/components/Schemas"
import { NewsletterTeaser } from "@/components/resources/components/TeaserGrid/NewsletterTeaser"
import type { Article } from "@/components/resources/data/posts.types"

const toArticle = (post: Beehiiv.Post): Article => {
  const publishedAt = post.publish_date
    ? new Date(post.publish_date * 1000).toISOString()
    : ""

  return {
    id: post.id,
    publishedAt,
    // Beehiiv has no last edit date
    modifiedAt: publishedAt,
    slug: post.slug,
    title: post.title,
    subtitle: post.subtitle,
    tags: post.content_tags,
    image: post.thumbnail_url,
    categoryName: "Newsletter",
    category: "newsletter",
    releaseNumber: 1,
    projectMeta: null,
    tableOfContents: null,
    author: {
      // The byline links to this author page
      id: "token-terminal",
      slug: "token-terminal",
      nickname: "Newsletter",
      firstname: "Token",
      lastname: "Terminal",
      title: "",
      image: "",
      isGuest: false,
      schemaType: "Organization",
      socials: [],
    },
  }
}

// `html` is the article body from toArticleHtml, already sanitized on the server
export const BeehiivArticlePage = ({
  post,
  html,
}: {
  post: Beehiiv.Post
  html: string
}) => {
  const article = toArticle(post)

  return (
    <article className="mb-8 md:mb-12 lg:mb-16">
      <div className="max-w-7xl mx-auto px-4">
        <ArticleHero
          categoryName={article.categoryName}
          category={article.category}
          title={article.title}
          subtitle={article.subtitle}
          image={article.image}
          publishedAt={article.publishedAt}
          releaseNumber={article.releaseNumber}
          projectMeta={article.projectMeta}
          author={article.author}
        />
      </div>
      <div className="max-w-3xl mx-auto px-4">
        <div
          dangerouslySetInnerHTML={{ __html: html }}
          className="beehiiv-content"
        />
        <Disclaimer />
      </div>
      <div className="flex justify-center mb-8 md:mb-12 lg:mb-16 pt-8 md:pt-12 lg:pt-16 max-w-5xl mx-auto px-4">
        <NewsletterTeaser as="section" />
      </div>
      <ArticleSchema article={article} />
    </article>
  )
}
